import React from 'react';
import Immutable from 'immutable';

import { Profile } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { ProfileDefault } from '../../../types/uncinc_profile/profile';

interface ViewPersonOverviewProps {
  entities: Immutable.List<ImmutableEntity<ProfileDefault>>;
}

const ViewPersonsFiltered: React.FC<ViewPersonOverviewProps> = ({
  entities,
}) => {
  const promotedEntities = entities.filter((entity) => entity.getIn(['field_promoted', 0, 'value'], false));
  const nonPromotedEntities = entities.filter((entity) => !entity.getIn(['field_promoted', 0, 'value'], false));

  return (
    <Container>
      <div className="ViewPersonsOverview">
        <div className="row">
          {promotedEntities.concat(nonPromotedEntities).map((entity) => {
            const person = entity.toJS();

            const uuid = person.uuid[0].value;
            const langcode = person.langcode[0].value;
            const key = `${uuid}:${langcode}`;
            const external = person.field_external[0].value;

            return !external && (
              <div className="col-12 col-lg-4" key={key}>
                <Profile
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ViewPersonsFiltered;
